import { render, staticRenderFns } from "./SmsService.vue?vue&type=template&id=1806ce14&scoped=true"
import script from "./SmsService.vue?vue&type=script&lang=js"
export * from "./SmsService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1806ce14",
  null
  
)

export default component.exports